import { drawing, geometry, Color } from '@progress/kendo-drawing';
import { isString } from '../utils/functions.js';
import { TRANSPARENT } from '../constants.js';

function sizeOptionsOrDefault(options) {
    return {
        x: options.x || 0,
        y: options.y || 0,
        width: options.width || 0,
        height: options.height || 0
    };
}
function normalizeDrawingOptions(options) {
    if (options) {
        let drawingOptions = options;
        if (isString(drawingOptions)) {
            drawingOptions = {
                color: drawingOptions
            };
        }
        if (drawingOptions.color) {
            drawingOptions.color = getColor(drawingOptions.color);
        }
        return drawingOptions;
    }
}
function getColor(value) {
    let color;
    if (value !== TRANSPARENT) {
        color = new Color(value).toHex();
    }
    else {
        color = value;
    }
    return color;
}
function lineAngle(p1, p2) {
    const xDiff = p2.x - p1.x;
    const yDiff = p2.y - p1.y;
    const angle = drawing.util.deg(Math.atan2(yDiff, xDiff));
    return angle;
}
function createSegment(x, y) {
    return new geometry.Segment(new geometry.Point(x, y));
}
function toDrawingRect(rect) {
    if (rect) {
        return new geometry.Rect([rect.x, rect.y], [rect.width, rect.height]);
    }
}

export { createSegment, getColor, lineAngle, normalizeDrawingOptions, sizeOptionsOrDefault, toDrawingRect };
